import {Link} from 'react-router-dom';
import * as React from 'react';
import {IChannel} from '../../../../../../data/api/models';
import Signpost from '../Signpost';

interface INoCoverAvailableProps {
  promptSingleQuote: boolean;
  channel: IChannel;
  quoteReference: string;
  callMessage: string;
  signpost: string;
}

const NoCoverAvailable = ({
                            promptSingleQuote,
                            channel,
                            quoteReference,
                            callMessage,
                            signpost,
                          }: INoCoverAvailableProps) => {

  const phoneNumber = channel.referralNumber ? channel.referralNumber : channel.phone;
  const unableToCompleteQuoteMessage = (
    <div>
      <p>Sorry, we are not able to complete your quotation online as we need a few more details.<br /><br />
        Simply call our UK-based specialist customer service{' '}
        team on {phoneNumber} quoting <b>{quoteReference}</b> who will discuss your requirements with you.<br /><br />
        We are open {channel.openingHours}, closed Bank Holidays.
      </p>
    </div>
  );

  if (signpost) {
    return (
      <>
        <Signpost signpost={signpost} channel={channel} />
        <hr/>
        {unableToCompleteQuoteMessage}
      </>
    );
  }

  if (promptSingleQuote) {
    return (
      <div>
        <p>
          Unfortunately, we are unable to offer you Annual cover at this time - please apply for Single
          Trip cover:
          <Link to="/" className="edit-trip-cover">
            here
          </Link>
        </p>
      </div>
    );
  }

  return unableToCompleteQuoteMessage;
};
export default NoCoverAvailable;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoice/components/NoCoverAvailable/index.tsx